import { FETCH_ORG_HIERARCHY } from '../actions/AppConfigsActions';

const orgHierarchyReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_ORG_HIERARCHY:
      return action.orgHierarchy;

    default:
      return state;
  }
};

export default orgHierarchyReducer;
